export default {
	FETCH_PRODUCTS: 'FETCH_PRODUCTS',
	FETCH_PRODUCTS_BY_CATEGORY: 'FETCH_PRODUCTS_BY_CATEGORY',
	FETCH_PRODUCT_BY_SLUG: 'FETCH_PRODUCT_BY_SLUG',
	SEARCH_PRODUCTS: 'SEARCH_PRODUCTS',
	COMPARE_PRODUCT_PRIMARY: 'COMPARE_PRODUCT_PRIMARY',
	COMPARE_PRODUCT_SECONDARY: 'COMPARE_PRODUCT_SECONDARY',
	REMOVE_COMPARE_PRODUCT_PRIMARY: 'REMOVE_COMPARE_PRODUCT_PRIMARY',
	REMOVE_COMPARE_PRODUCT_SECONDARY: 'REMOVE_COMPARE_PRODUCT_SECONDARY',

	FETCHING_PRODUCT_IN_PROGRESS: 'FETCHING_PRODUCT_IN_PROGRESS',
	FETCHING_PRODUCT_SUCCEEDED: 'FETCHING_PRODUCT_SUCCEEDED',
	FETCHING_PRODUCT_FAILED: 'FETCHING_PRODUCT_FAILED',
	CHECK_BEFORE_FETCH: 'CHECK_BEFORE_FETCH',

	REMOVE_PRODUCT: 'REMOVE_PRODUCT',

	GO_TO_NEXT_ITEM: 'GO_TO_NEXT_ITEM',
	GO_TO_PREVIOUS_ITEM: 'GO_TO_PREVIOUS_ITEM',
};



// WEBPACK FOOTER //
// ./src/redux/product/actionTypes.js